import { TContactForm } from '../model/forms'
import { IContact } from '../model/types'

export const ContactFormContent: TContactForm<
  Pick<
    IContact,
    | 'firstName'
    | 'lastName'
    | 'email'
    | 'hpRoles'
    | 'salutation'
    | 'seniority'
    | 'primaryJobRole'
    | 'countryOfBusiness'
    | 'preferredLanguage'
    | 'mobilePhoneCode'
    | 'mobilePhoneNumber'
    | 'workPhoneCode'
    | 'workPhoneNumber'
    | 'isNeverCall'
    | 'isNeverEmail'
    | 'emailPixels'
    | 'relationshipStrength'
    | 'changeMindset'
    | 'role'
    | 'contactStatus'
    | 'competitors'
    | 'isPreferredContact'
    | 'isHPHero'
    | 'whatsAppLink'
    | 'twitterLink'
    | 'linkedInLink'
    | 'facebookLink'
  >,
  {
    general: string
    common: string
    communicationPreferences: string
    hpRoles: string
    additional: string
  }
> = {
  titles: {
    general: 'contact_forms-title-general',
    common: 'contact_forms-title-common',
    communicationPreferences: 'contact_forms-title-communication_preferences',
    hpRoles: 'contact_forms-title-hp_roles',
    additional: 'contact_forms-title-additional',
  },
  fields: {
    firstName: {
      field: 'firstName',
      label: 'contact_forms-field-firstName',
    },
    lastName: {
      field: 'lastName',
      label: 'contact_forms-field-lastName',
    },
    email: {
      field: 'email',
      label: 'contact_forms-field-email',
    },
    hpRoles: {
      field: 'hpRoles',
      label: 'contact_forms-field-hp_roles',
    },
    salutation: {
      field: 'salutation',
      label: 'contact_forms-field-salutation',
    },
    seniority: {
      field: 'seniority',
      label: 'contact_forms-field-seniority',
    },
    primaryJobRole: {
      field: 'primaryJobRole',
      label: 'contact_forms-field-primary_job_role',
    },
    countryOfBusiness: {
      field: 'countryOfBusiness',
      label: 'contact_forms-field-country_of_business',
    },
    preferredLanguage: {
      field: 'preferredLanguage',
      label: 'contact_forms-field-preferred_language',
    },
    mobilePhoneCode: {
      field: 'mobilePhoneCode',
      label: 'contact_forms-field-mobile_phone_code',
    },
    mobilePhoneNumber: {
      field: 'mobilePhoneNumber',
      label: 'contact_forms-field-mobile_phone_number',
    },
    workPhoneCode: {
      field: 'workPhoneCode',
      label: 'contact_forms-field-work_phone_code',
    },
    workPhoneNumber: {
      field: 'workPhoneNumber',
      label: 'contact_forms-field-work_phone_number',
    },
    isNeverCall: {
      field: 'isNeverCall',
      label: 'contact_forms-field-is_never_call',
    },
    isNeverEmail: {
      field: 'isNeverEmail',
      label: 'contact_forms-field-is_never_email',
    },
    emailPixels: {
      field: 'emailPixels',
      label: 'contact_forms-field-email_pixels',
    },
    relationshipStrength: {
      field: 'relationshipStrength',
      label: 'contact_forms-field-relationship_strength',
    },
    changeMindset: {
      field: 'changeMindset',
      label: 'contact_forms-field-change_mindset',
    },
    role: {
      field: 'role',
      label: 'contact_forms-field-role',
    },
    contactStatus: {
      field: 'contactStatus',
      label: 'contact_forms-field-contact_status',
    },
    competitors: {
      field: 'competitors',
      label: 'contact_forms-field-competitors',
    },
    isPreferredContact: {
      field: 'isPreferredContact',
      label: 'contact_forms-field-is_preferred_contact',
    },
    isHPHero: {
      field: 'isHPHero',
      label: 'contact_forms-field-is_hp_hero',
    },
    whatsAppLink: {
      field: 'whatsAppLink',
      label: 'contact_forms-field-whats_app_link',
    },
    facebookLink: {
      field: 'facebookLink',
      label: 'contact_forms-field-facebook_link',
    },
    linkedInLink: {
      field: 'linkedInLink',
      label: 'contact_forms-field-linked_in_link',
    },
    twitterLink: {
      field: 'twitterLink',
      label: 'contact_forms-field-twitter_link',
    },
  },
} as const
